import { render } from "./DocumentClassTablesSubView.vue?vue&type=template&id=0c20d012&scoped=true&ts=true"
import script from "./DocumentClassTablesSubView.vue?vue&type=script&lang=ts"
export * from "./DocumentClassTablesSubView.vue?vue&type=script&lang=ts"

import "./DocumentClassTablesSubView.vue?vue&type=style&index=0&id=0c20d012&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c20d012"]])

export default __exports__